function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardToolTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 266,
    height: 64.729,
    viewBox: "0 0 266 64.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Copied to clipboard"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 80",
    d: "M4817 13414.557a7 7 0 0 1-7-7v-37a7 7 0 0 1 7-7h111l13.14-13.143a2 2 0 0 1 2.828 0l13.144 13.143H5069a7 7 0 0 1 7 7v37a7 7 0 0 1-7 7z",
    transform: "translate(-4810.001 -13349.827)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardToolTip);
export default __webpack_public_path__ + "static/media/clipboardToolTip.575d875c00b486d24dd037a025dfe151.svg";
export { ForwardRef as ReactComponent };